import { ApiResourceModel } from "../ApiResourceModel";
/**
 * Represents the guest user's model based on the server's retrieved data.
 */
export class GuestUser extends ApiResourceModel {
    constructor(args = {}) {
        super();
        this.clientId = args.clientId;
        this.username = args.username;
        this.password = args.password || "";
        this.organization = args.organization || "";
    }
}
//# sourceMappingURL=GuestUser.js.map